import settings from '../../../settings.json';

// https://docs.mapbox.com/help/glossary/access-token/
let token = settings.MAPBOX_KEY;

const contextKey = {};

export { token, contextKey };
